import { useTranslation } from 'react-i18next';

import {
  Form,
  NumberInput,
  PLATFORM_THEME_COLORS,
  TextInput,
} from '@thinknet-gmbh/platform-common-ui';

import { TitleRowLabel, StyledContainer, StyledRowContainer } from '../../employee-common.styles';


const WorkingInformation = () => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  return (
    <StyledContainer>
      <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:workingConditions.labels.workingAndVacation')}
      </TitleRowLabel>
      <StyledRowContainer>
        <Form.Item
          name={'weeklyHours'}
          label={t('employee:labels.weeklyHours')}
          rules={[
            {
              required: true,
              message: t('employee:validationError.weeklyHoursRequired'),
            },
          ]}
        >
          <NumberInput customInput={TextInput} placeholder="40 hr" suffix=" hr" maxLength={8} />
        </Form.Item>
        <Form.Item
          name={'paidVacation'}
          label={t('employee:workingConditions.labels.paidVacation')}
          rules={[
            {
              required: true,
              message: t('employee:workingConditions.validation.paidVacationRequired'),
            },
          ]}
        >
          <NumberInput
            placeholder={`40 ${t('common:labels.times.days')}`}
            suffix={` ${t('common:labels.times.days')}`}
            maxLength={7}
          />
        </Form.Item>
      </StyledRowContainer>
    </StyledContainer>
  );
};

export default WorkingInformation;
